import { FormatUrlParameters } from '@garmin/support-utils';

import { capi } from '../../client';
// eslint-disable-next-line import/no-cycle
import {
  addExpandCollapseButton,
  formatFaqInPageAnchors,
  getFormattedEmbeddedFaqContent,
  getFormattedEmbeddedPrivateFaqContent,
  updateDocumentTitleFaq,
} from './util';

const getDefaultState = () => ({
  faqDetails: false,
});

export default {
  state: getDefaultState(),

  getters: {
    faqDetails: (state) => state.faqDetails,
    formatFaqInPageAnchors,
    getFormattedEmbeddedFaqContent,
    getFormattedEmbeddedPrivateFaqContent,
    addExpandCollapseButton,
    getFaqDetailsQuery: () => (params) => new URLSearchParams(FormatUrlParameters.stripFalsyProps({
      locale: params.locale,
      faqId: params.faq,
      agentUserId: window.AppData?.username,
    })).toString(),
  },

  mutations: {
    resetFaqModule(state) {
      Object.assign(state, getDefaultState());
    },

    faqDetailsUpdate(state, detailsObj) {
      // eslint-disable-next-line no-param-reassign
      state.faqDetails = detailsObj;
    },
  },

  actions: {
    resetFaqModule({ commit }) {
      commit('resetFaqModule');
    },
    async fetchFaqDetails({ commit, getters }, params) {
      const apiId = 'fetchFaqDetails';
      if (getters.isApiIdCallInProgress(apiId)) return;
      commit('incrementApiCallsInProgress', apiId, { root: true });

      try {
        let faqDetails;
        const { apiData } = window.AppData;
        const locale = params.altLocale || getters.locale;
        const qs = `?${getters.getFaqDetailsQuery({ ...params, locale })}`;
        const servicePath = getters.isInternal ? `faqInternal/${locale}/${qs}` : `faq/details/${qs}`;

        if (apiData?.faq && apiData.faq.contentID === params.faq && !params.altLocale) {
          faqDetails = apiData.faq;
        } else {
          const { data } = await capi.get(servicePath);
          faqDetails = data;
        }

        // not showing attachements until SAML is integrated
        if (getters.isInternal && faqDetails) {
          faqDetails.attachments = [];
        }

        if (!faqDetails?.content && !faqDetails?.privateContent) {
          commit('faqDetailsUpdate', getDefaultState().faqDetails);
        } else {
          if (faqDetails.contentMap) {
            faqDetails.content = getters.getFormattedEmbeddedFaqContent(
              faqDetails.contentMap,
              faqDetails.content,
            );
          }

          if (faqDetails.privateContent) {
            const formattedContent = getters.getFormattedEmbeddedPrivateFaqContent(
              faqDetails.privateContent,
            );

            faqDetails.privateContent = getters.formatFaqInPageAnchors(formattedContent);
          }

          const topicTag = params.topicTag === false ? '' : getters.getGeneralTagNameFromId(params.topicTag);
          const tab = params.tab || getters.selectedTab;

          setTimeout(() => {
            updateDocumentTitleFaq(faqDetails, getters.product, getters.nonHomePageTitle, tab, topicTag, getters.sas_source);

            // eslint-disable-next-line no-param-reassign
            getters.sas_source = '';
          }, 1000);

          faqDetails.content = getters.formatFaqInPageAnchors(faqDetails.content);

          faqDetails.content = getters.addExpandCollapseButton(faqDetails.content);

          faqDetails.privateContent = getters.addExpandCollapseButton(faqDetails.privateContent, true);

          commit('faqDetailsUpdate', faqDetails);
        }
      } catch (e) {
        console.log(e);
        commit('faqDetailsUpdate', getDefaultState().faqDetails);
      } finally {
        commit('decrementApiCallsInProgress', apiId, { root: true });
      }
    },
  },
};
